import { useState, useEffect, useRef } from "react";
import dropdownIcon from "../../assets/Icons/Dropdown.svg";
import tickIcon from "../../assets/Icons/Check.svg"; // Add a tick icon asset
import { calculateLocalDeadline } from "../../utils/formatting";

function CustomDropDown({
  label,
  id,
  name,
  value,
  onChange,
  onBlur,
  error,
  options,
  defaultOption = "Select an option",
  idKey,
  valueKey,
  dropdownDivStyle = "",
  labelStyle = "",
  dropdownStyle = "",
  dropDownIconStyle = "",
  optionStyle = "",
  disabled = false,
  extraAdderKey = "" 
}) {

  const [isOpen, setIsOpen] = useState(false);
  
  const dropdownRef = useRef(null);

  const handleSelect = (option) => {
    onChange(name, option[valueKey]);
    onBlur(name, option[valueKey]);
    setIsOpen(false);
  };

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="mb-6" ref={dropdownRef}>
      {label && (
        <label
          htmlFor={id}
          className={`form-label block font-inter text-secondary text-level-3 font-medium leading-[24px] ${labelStyle}`}
        >
          {label} <span className="text-light-red">*</span>
        </label>
      )}
      <div
        className={`relative mt-[12px] ${dropdownDivStyle}`}
        onClick={() => !disabled && setIsOpen(!isOpen)}
      >
        <div
          className={`flex items-center justify-between mt-[12px] px-[12px] font-inter py-[12px] h-12 w-full rounded-[5px] text-[15px] border-[1.5px] border-medium-gray cursor-pointer ${dropdownStyle} ${
            disabled ? "opacity-50 cursor-not-allowed" : ""
          } ${value ? "text-black/80" : "text-gray/60"}`}
          aria-expanded={isOpen}
          role="button"
          tabIndex="0"
        >
          {value ? value : defaultOption}
          <img
            src={dropdownIcon}
            alt="dropdown"
            className={`${dropDownIconStyle}`}
          />
        </div>
        {error && (
          <p className="mt-1 pl-0 text-xs font-medium text-red-400 absolute -bottom-[20px]">
            {error}
          </p>
        )}
        {isOpen && (
          <ul
            className="absolute left-0 right-0 mt-1 bg-white border border-medium-gray rounded-[5px] z-10"
            style={{
              boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.1)",
              maxHeight: "250px", // Set a maximum height
              overflowY: "auto", // Enable scrolling when options exceed max-height
            }}
            role="menu"
          >
            {/*dropdown options*/}
            {options.map((option) => (
              <li
                key={option[idKey]}
                onClick={() => handleSelect(option)}
                className={`flex items-center justify-between px-3 py-2 cursor-pointer ${optionStyle} ${
                  value === option.name ? "text-primary bg-blue-100" : "text-gray bg-white"
                } hover:text-primary`}
                role="menuitem"
                tabIndex="0"
              >
                {option[valueKey] + (option[extraAdderKey] ? " " + option[extraAdderKey] : "")}
                {value === option.name && (
                  <img
                    src={tickIcon}
                    alt="selected"
                    className="w-[20px] h-[20px] ml-2"
                  />
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default CustomDropDown;
